import React, { memo } from "react";

// utils
import { contractTableMoneyFormat, moneyFormatter } from "bodycodi/cmap/app/js/common";

const SalesTab = ({ details }: any) => {
  const COMMISSION_PAYMENT_TYPE: any = {
    AMOUNT: "정액제",
    RATE: "정률제",
  };

  const COMMISSION_BASE_TYPE: any = {
    SALESPRICE: "판매금액 기준",
    PAYMENTAMOUNT: "결제금액 기준",
  };

  const COMMISSION_VAT_YN: any = {
    Y: "부가세 포함 후 정산",
    N: "부가세 제외 후 정산",
  };

  const REFUND_APPLY_TARGET: any = {
    SALES: "판매 담당자",
    REFUND: "환불 담당자",
  };

  const COMISSION_TABLE_TITLE: any = {
    PERSONAL: "개인 영업 커미션",
    TEAM: "팀 영업 커미션",
    CENTER: "센터 영업 커미션",
  };

  const renderTables = () => {
    return details?.commissions.map((commission: any, index: number) => {
      return details?.commissionPaymentType === "AMOUNT" ? (
        <AmountTable
          key={index}
          title={COMISSION_TABLE_TITLE[commission?.commissionType]}
          labelBadge={
            commission.commissionType === "TEAM" &&
            (details?.teamCommissionType === "PERSONAL" ? "개인 매출" : "팀 매출")
          }
          sections={commission?.amountSections}
        />
      ) : (
        <RateTable
          key={index}
          title={COMISSION_TABLE_TITLE[commission?.commissionType]}
          labelBadge={
            commission.commissionType === "TEAM" &&
            (details?.teamCommissionType === "PERSONAL" ? "개인 매출" : "팀 매출")
          }
          sections={commission}
        />
      );
    });
  };

  return (
    <div className="tab-content no-horizontal-padding">
      <div className="horizontal-padding">
        <span className="tab-title">영업 커미션</span>

        <div className="section">
          <span>커미션 지급 방식</span>
          <span>
            {details?.commissionPaymentType
              ? COMMISSION_PAYMENT_TYPE[details?.commissionPaymentType]
              : "미설정"}
          </span>
        </div>

        <div className="section">
          <span>커미션 대상 금액 기준</span>
          <span>
            {details?.commissionBaseType
              ? COMMISSION_BASE_TYPE[details?.commissionBaseType]
              : "미설정"}
          </span>
        </div>

        <div className="section">
          <span>부가세 포함여부</span>
          <span>
            {details?.commissionVatYn ? COMMISSION_VAT_YN[details?.commissionVatYn] : "미설정"}
          </span>
        </div>

        <div className="section no-margin">
          <span>마이너스 매출 담당자</span>
          <span>
            {details?.refundApplyTarget
              ? REFUND_APPLY_TARGET[details?.refundApplyTarget]
              : "미설정"}
          </span>
        </div>
      </div>

      {renderTables()}
    </div>
  );
};

const AmountTable = ({ title, labelBadge = null, sections }: any) => {
  return (
    <>
      <div className="table-title with-horizontal-padding">
        {title}
        {labelBadge && <span>{labelBadge}</span>}
      </div>
      <table className="sales-table">
        <thead style={{ height: 38 }}>
          <tr>
            <th colSpan={3} style={{ width: "65%", minWidth: 265, borderLeft: "none" }}>
              구간 정보
            </th>
            <th style={{ width: "35%", minWidth: 92, border: "none" }}>커미션 (원)</th>
          </tr>
        </thead>
        <tbody>
          {sections?.map((section: any, index: number) => {
            return (
              <tr key={index}>
                <td colSpan={3} className="blue-text" style={{ borderLeft: "none" }}>
                  {`${contractTableMoneyFormat(
                    section?.sectionMore,
                    "이상"
                  )} ${contractTableMoneyFormat(section?.sectionLess, "이하")}`}
                </td>
                <td
                  className={section?.newPayroll > 0 ? "active" : ""}
                  style={{ borderRight: "none", textAlign: "center" }}
                >
                  {moneyFormatter(section?.newPayroll, true)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

const RateTable = ({ title, labelBadge = null, sections }: any) => {
  return (
    <>
      <div className="table-title with-horizontal-padding">
        {title}
        {labelBadge && <span>{labelBadge}</span>}
      </div>
      <table className="sales-table">
        <thead style={{ height: 58 }}>
          <tr>
            <th rowSpan={2} style={{ width: "13%", minWidth: 60, border: "none" }}>
              {`이용권 \n종류`}
            </th>
            <th
              style={{ width: "61%", minWidth: 265, borderBottom: "none" }}
              rowSpan={2}
              colSpan={3}
            >
              구간 정보
            </th>
            <th style={{ width: "26%", minWidth: 120, borderRight: "none" }} colSpan={2}>
              커미션(%)
            </th>
          </tr>
          <tr>
            <th style={{ width: 60, borderBottom: "none" }}>신규 결제</th>
            <th style={{ width: 60, border: "none" }}>재결제</th>
          </tr>
        </thead>
        <tbody>
          {!!sections?.personalSections.length && (
            <>
              <tr>
                <td className="gray-background" rowSpan={sections?.personalSections.length}>
                  개인
                </td>

                <td className="blue-text" colSpan={3}>
                  {`${contractTableMoneyFormat(
                    sections?.personalSections[0]?.sectionMore,
                    "이상"
                  )} ${contractTableMoneyFormat(
                    sections?.personalSections[0]?.sectionLess,
                    "이하"
                  )}`}
                </td>
                <td className={sections?.personalSections[0]?.newPayroll > 0 ? "active" : ""}>
                  {sections?.personalSections[0]?.newPayroll}
                </td>
                <td className={sections?.personalSections[0]?.inusePayroll > 0 ? "active" : ""}>
                  {sections?.personalSections[0]?.inusePayroll}
                </td>
              </tr>

              {sections?.personalSections?.slice(1).map((section: any, index: number) => {
                return (
                  <tr key={index}>
                    <td className="blue-text" colSpan={3}>
                      {`${contractTableMoneyFormat(
                        section?.sectionMore,
                        "이상"
                      )} ${contractTableMoneyFormat(section?.sectionLess, "이하")}`}
                    </td>
                    <td className={section?.newPayroll > 0 ? "active" : ""}>
                      {section?.newPayroll}
                    </td>
                    <td className={section?.inusePayroll > 0 ? "active" : ""}>
                      {section?.inusePayroll}
                    </td>
                  </tr>
                );
              })}
            </>
          )}

          {!!sections?.groupSections.length && (
            <>
              <tr>
                <td className="gray-background" rowSpan={sections?.groupSections.length}>
                  그룹
                </td>

                <td className="blue-text" colSpan={3}>
                  {`${contractTableMoneyFormat(
                    sections?.groupSections[0]?.sectionMore,
                    "이상"
                  )} ${contractTableMoneyFormat(sections?.groupSections[0]?.sectionLess, "이하")}`}
                </td>
                <td className={sections?.groupSections[0]?.newPayroll > 0 ? "active" : ""}>
                  {sections?.groupSections[0]?.newPayroll}
                </td>
                <td className={sections?.groupSections[0]?.inusePayroll > 0 ? "active" : ""}>
                  {sections?.groupSections[0]?.inusePayroll}
                </td>
              </tr>

              {sections?.groupSections?.slice(1).map((section: any, index: number) => {
                return (
                  <tr key={index}>
                    <td className="blue-text" colSpan={3}>
                      {`${contractTableMoneyFormat(
                        section?.sectionMore,
                        "이상"
                      )} ${contractTableMoneyFormat(section?.sectionLess, "이하")}`}
                    </td>
                    <td className={section?.newPayroll > 0 ? "active" : ""}>
                      {section?.newPayroll}
                    </td>
                    <td className={section?.inusePayroll > 0 ? "active" : ""}>
                      {section?.inusePayroll}
                    </td>
                  </tr>
                );
              })}
            </>
          )}

          {!!sections?.placeSections.length && (
            <>
              <tr>
                <td className="gray-background" rowSpan={sections?.placeSections.length}>
                  시설
                </td>

                <td className="blue-text" colSpan={3}>
                  {`${contractTableMoneyFormat(
                    sections?.placeSections[0]?.sectionMore,
                    "이상"
                  )} ${contractTableMoneyFormat(sections?.placeSections[0]?.sectionLess, "이하")}`}
                </td>
                <td className={sections?.placeSections[0]?.newPayroll > 0 ? "active" : ""}>
                  {sections?.placeSections[0]?.newPayroll}
                </td>
                <td className={sections?.placeSections[0]?.inusePayroll > 0 ? "active" : ""}>
                  {sections?.placeSections[0]?.inusePayroll}
                </td>
              </tr>

              {sections?.placeSections?.slice(1).map((section: any, index: number) => {
                return (
                  <tr key={index}>
                    <td className="blue-text" colSpan={3}>
                      {`${contractTableMoneyFormat(
                        section?.sectionMore,
                        "이상"
                      )} ${contractTableMoneyFormat(section?.sectionLess, "이하")}`}
                    </td>
                    <td className={section?.newPayroll > 0 ? "active" : ""}>
                      {section?.newPayroll}
                    </td>
                    <td className={section?.inusePayroll > 0 ? "active" : ""}>
                      {section?.inusePayroll}
                    </td>
                  </tr>
                );
              })}
            </>
          )}

          {!!sections?.optionSections.length && (
            <>
              <tr>
                <td className="gray-background" rowSpan={sections?.optionSections.length}>
                  옵션
                </td>

                <td className="blue-text" colSpan={3}>
                  {`${contractTableMoneyFormat(
                    sections?.optionSections[0]?.sectionMore,
                    "이상"
                  )} ${contractTableMoneyFormat(sections?.optionSections[0]?.sectionLess, "이하")}`}
                </td>
                <td className={sections?.optionSections[0]?.newPayroll > 0 ? "active" : ""}>
                  {sections?.optionSections[0]?.newPayroll}
                </td>
                <td className={sections?.optionSections[0]?.inusePayroll > 0 ? "active" : ""}>
                  {sections?.optionSections[0]?.inusePayroll}
                </td>
              </tr>

              {sections?.optionSections?.slice(1).map((section: any, index: number) => {
                return (
                  <tr key={index}>
                    <td className="blue-text" colSpan={3}>
                      {`${contractTableMoneyFormat(
                        section?.sectionMore,
                        "이상"
                      )} ${contractTableMoneyFormat(section?.sectionLess, "이하")}`}
                    </td>
                    <td className={section?.newPayroll > 0 ? "active" : ""}>
                      {section?.newPayroll}
                    </td>
                    <td className={section?.inusePayroll > 0 ? "active" : ""}>
                      {section?.inusePayroll}
                    </td>
                  </tr>
                );
              })}
            </>
          )}
        </tbody>
      </table>
    </>
  );
};

export default memo(SalesTab);
